/**
 * Sources de brouillon d'une page : plusieurs composants d'une même page peuvent signaler un brouillon (formulaire en
 * cours de saisie, fichiers en cours d'envoi…). La page reste en brouillon tant qu'au moins une source est active :
 * la fin d'une source ne doit pas effacer le brouillon d'une autre (le dernier qui écrit ne gagne pas).
 */
export class SourcesBrouillon {
  private readonly pages = new Map<string, Set<symbol>>();

  activer(page: string, source: symbol): void {
    const s = this.pages.get(page) ?? new Set<symbol>();
    s.add(source);
    this.pages.set(page, s);
  }

  /** Retire la source ; vrai si la page n'a plus aucun brouillon. */
  desactiver(page: string, source: symbol): boolean {
    const s = this.pages.get(page);
    s?.delete(source);
    if (s?.size) return false;
    this.pages.delete(page);
    return true;
  }

  actif(page: string): boolean {
    return !!this.pages.get(page)?.size;
  }

  /** Au moins une page a un brouillon (sortie d'AGORA : useQuitterAgora). */
  enCours(): boolean {
    return this.pages.size > 0;
  }
}
